<div class="ipm-report__buttons ipm-report__buttons--dialog">
  <button mat-raised-button color="primary" [hidden]="!canCurrentUserAOApprove" (click)="approveByAO()">Approve Task</button>
  <button mat-raised-button [disabled]="isReportUpdating()" color="primary" class="ipm-report__buttons__pdf" (click)="generatePdf()">
    {{ 'measurementReport.generatePDFText' | translate }}
  </button>
  @if (!isShowRejectBtn) {
    <button
      mat-mini-fab
      color="primary"
      (click)="reject()"
      [disabled]="isRejectDisabled || isApproveDisabled"
      [matTooltip]="'measurementReport.reject' | translate"
      matTooltipPosition="above"
      matTooltipClass="osc-tooltip"
      [ngClass]="{ 'osc-button--loading': isRejectInProgress }"
    >
      <mat-icon svgIcon="icon-ban"></mat-icon>
    </button>
  }
  @if (isApprover) {
    <button
      mat-mini-fab
      color="primary"
      (click)="approve()"
      [ngClass]="{ 'osc-button--loading': isApprovalInProgress }"
      [disabled]="isApproveDisabled"
      [matTooltip]="'measurementReport.approve' | translate"
      matTooltipPosition="above"
      matTooltipClass="osc-tooltip"
    >
      <mat-icon svgIcon="file-signature"></mat-icon>
    </button>
  }
</div>
<app-report
  #report
  [projectId]="projectId"
  [jobId]="jobId"
  [taskId]="taskId"
  [inspectionType]="inspectionType"
  data-testid="report"
  [readOnly]="isReportReadOnly"
></app-report>
